// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_frontend_components_agromarket_components_Footer_index_js-node_modules_f-371657"], function() { return __webpack_require__(343081); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
